import { styled } from '@/styles/stitches';

export const LogoContainer = styled('div', {
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  padding: '0 $3',
  marginBottom: '5.25rem',
});

export const AsideContainer = styled('div', {
  width: '12rem',
  height: '100vh',
  position: 'sticky',
  top: '0',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '$15 0 6rem 0',
});

export const SelectContainer = styled('div', {});

// export const Select;
